import axios from "axios";
import authHeader from "./auth-header";
import { logout } from "../reducers/actions";
import store from "../reducers/store";
import { refresh } from "../reducers/actions";

const axiosApiInstance = axios.create();
axiosApiInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response.status === 401 || error.response.status === 422) {

            //localStorage.removeItem("reduxState");
            logout()(store.dispatch);
        }

        return Promise.reject(error.message);
    }
);



class BackendService {


    downloadRootCACert() {
        return axiosApiInstance
            .get(window.config.API_URL + "download-root-ca", { headers: authHeader() })
            .then(
                (response) => {
                    return response;
                },
                (error) => {
                    return [];
                }
            );
    }
    downloadAuthCACert() {
        return axiosApiInstance
            .get(window.config.API_URL + "download-auth-ca", { headers: authHeader() })
            .then(
                (response) => {
                    return response;
                },
                (error) => {
                    return [];
                }
            );
    }

    postDownfile = (endpoint, requestJson) => {
        let head = { headers: authHeader(), responseType: 'arraybuffer' };
        const makeRequest = async () => {
            const response = await axios.post(window.config.API_URL + endpoint, requestJson, head );
            return response.data
        };
        return makeRequest();
    }

    postJSON = (endpoint, requestJson, is_file = false, reload = false, withmsg = false, downloadfile = false) => {

        let head = { headers: authHeader() };
        let retryCount = 0;
        let maxRetries = 3;

        if (is_file) {
            head = { headers: authHeader(), 'Content-Type': 'multipart/form-data' };
        }

        const makeRequest = async () => {
            try {
                const response = await axios.post(window.config.API_URL + endpoint, requestJson, head);

                if (reload) {
                    window.location = window.location;
                }
                else {
                    if (downloadfile){
                        return response.data
                    }
                    if (!withmsg) {
                        return response.data.data ?? [];
                    }
                    else {
                        return { data: response.data.data ?? [], msg: response.data.msg ?? "" }
                    }
                }
            } catch (error) {

                if (retryCount < maxRetries && error.toString().includes('Error: Network Error')) {
                    retryCount++;
                    return makeRequest();
                } else {
                    if (error.toString().includes('Error: Network Error')) {
                        alert('Call to ' + endpoint + ' failed: Connection to Red Access unavailable')
                    }

                    if (error.toString().includes('401') || error.toString().includes('422')) {

                        if (authHeader() == "") {
                            window.location = "/login";
                        }

                        await refresh();

                        return await this.postJSON(endpoint, requestJson, is_file, reload, withmsg, downloadfile);
                    }
                    else if (error.toString().includes('403')) {

                        store.dispatch({
                            type: "TRIGGER_READONLY_POPUP",
                            payload: true,
                        })
                        return { data: [], msg: "OK" }
                    }

                    if (error.response) {

                        if (error.response.data) {

                            if (!withmsg) {
                                return error.response.data.data ?? []
                            }
                            else {
                                return { data: error.response.data.data ?? [], msg: error.response.data.msg ?? "" }
                            }
                        }
                    }
                }

                return [];
            }
        };

        return makeRequest();
    }



}

export default new BackendService();
